import { getSizeToken, getVariantToken } from '@koaly/mixins';
import classNames from 'classnames';
import React from 'react';
import { up } from 'styled-breakpoints';
import styled, { css } from 'styled-components';

const PrefixSuffix = styled.span `
  ${({ appearance, size, position }) => appearance === 'default' && css `
    margin-${position}: ${getSizeToken('button', 'mobilePaddingHorizontal', size)};

    ${up('s')} {
      margin-${position}: ${getSizeToken('button', 'paddingHorizontal', size)};
    }
  `};

  ${({ appearance, size, variant, position, iconOnly }) => appearance === 'cta' && css `
    margin-${position}: 8px;

    &:not(.hover):not(.focus) {
      ${iconOnly && css `margin: 0;`}
    }

    box-sizing: border-box;
    width: ${getSizeToken('button', 'prefixSuffixCircleMobileSize', size, appearance)};
    height: ${getSizeToken('button', 'prefixSuffixCircleMobileSize', size, appearance)};
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    justify-items: center;
    background-color: ${getVariantToken('button', 'prefixSuffixBackgroundColor', variant, appearance)};
    color: ${getVariantToken('button', 'prefixSuffixColor', variant, appearance)};

    &:hover, &.hover {
      background-color: ${getVariantToken('button', 'prefixSuffixBackgroundColorHover', variant, appearance)};
      color: ${getVariantToken('button', 'prefixSuffixColorHover', variant, appearance)};
    }

    &:focus, &.focus {
      background-color: ${getVariantToken('button', 'prefixSuffixBackgroundColorFocus', variant, appearance)};
      color: ${getVariantToken('button', 'prefixSuffixColorFocus', variant, appearance)};
    }

    ${up('s')} {
      width: ${getSizeToken('button', 'prefixSuffixCircleSize', size, appearance)};
      height: ${getSizeToken('button', 'prefixSuffixCircleSize', size, appearance)}
    }
  `}

  margin-${({ position }) => position === 'left' ? 'right' : 'left'}: ${({ size, appearance }) => getSizeToken('button', 'prefixSuffixSpacing', size, appearance)};

  ${up('s')} {
    margin-${({ position }) => position === 'left' ? 'right' : 'left'}: ${({ size, appearance }) => getSizeToken('button', 'prefixSuffixMobileSpacing', size, appearance)};
  }

  font-size: ${({ size, appearance }) => getSizeToken('button', 'prefixSuffixSize', size, appearance)};

`;
const Text = styled.span `
  ${({ size, hasSuffix, hasPrefix }) => css `
    ${!hasPrefix && css `
      padding-left: ${getSizeToken('button', 'mobilePaddingHorizontal', size)};
    `};

    ${!hasSuffix && css `
      padding-right: ${getSizeToken('button', 'mobilePaddingHorizontal', size)};
    `};

    ${up('s')} {
      ${!hasPrefix && css `
        padding-left: ${getSizeToken('button', 'paddingHorizontal', size)};
      `};

      ${!hasSuffix && css `
        padding-right: ${getSizeToken('button', 'paddingHorizontal', size)};
      `};
    }
  `};
  ${({ iconOnly }) => iconOnly && css `
    display: none;

    &.hover, &.focus {
      display: inline;
    }
  `}
`;
const ButtonInner = ({ prefix: PrefixElement, suffix: SuffixElement, size, children, appearance, variant, hover, focus, iconOnly, }) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const prefix = typeof PrefixElement === 'object' ? (React.createElement(PrefixElement, null)) : PrefixElement;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const suffix = typeof SuffixElement === 'object' ? (React.createElement(SuffixElement, null)) : SuffixElement;
    return (React.createElement(React.Fragment, null,
        prefix && (React.createElement(PrefixSuffix, { className: classNames({ hover: hover, focus: focus }), position: "left", size: size, appearance: appearance, variant: variant, iconOnly: iconOnly }, prefix)),
        React.createElement(Text, { className: classNames({ hover: hover, focus: focus }), size: size, hasPrefix: !!prefix, hasSuffix: !!suffix, appearance: appearance, iconOnly: iconOnly }, children),
        suffix && (React.createElement(PrefixSuffix, { className: classNames({ hover: hover, focus: focus }), position: "right", size: size, appearance: appearance, variant: variant, iconOnly: iconOnly }, suffix))));
};

export { ButtonInner };
//# sourceMappingURL=ButtonInner.js.map
